import { useEffect } from 'react';
import { Gallery, Item } from 'react-photoswipe-gallery';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';

import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';

const images = [
  [
    require('../../assets/img/work/bmj.png'),
    'BMJ Impact Analytics',
    'https://impactanalytics.bmj.com/home.php',
  ],
  [
    require('../../assets/img/work/tiiqu.png'),
    'QuTii Truth Library',
    'https://www.qutii.org/',
  ],
  [
    require('../../assets/img/work/stories.png'),
    'British Red Cross stories',
    'https://www.redcross.org.uk/stories',
  ],
  [
    require('../../assets/img/work/first_aid_champions.png'),
    'First aid champions',
    'https://firstaidchampions.redcross.org.uk/',
  ],
  [
    require('../../assets/img/work/angelica.png'),
    'Angelica Koumanakou',
    'https://www.angelicakoumanakou.com/',
  ],
  [
    require('../../assets/img/work/boosey.png'),
    'Boosey & Hawkes',
    'https://www.boosey.com/',
  ],
  [
    require('../../assets/img/work/cf_source.png'),
    'CF Source',
    'https://www.cfsourcehcp.com/',
  ],
  [
    require('../../assets/img/work/ipo.png'),
    'Intellectual property office',
    'https://www.ipo.gov.uk/ip-support/',
  ],
  [
    require('../../assets/img/work/somerset_house.png'),
    'Somerset house',
    'https://www.somersethouse.org.uk/',
  ],
  [
    require('../../assets/img/work/heineken.png'),
    'Heineken Sustainability Report 2012',
    'http://www.annualreports.com/Company/heineken-nv',
  ],
  [
    require('../../assets/img/work/vertex.png'),
    'Vertex',
    'https://www.vrtx.com/',
  ],
  [
    require('../../assets/img/work/wpp.png'),
    'WPP Annual Report 2012',
    'http://www.annualreports.co.uk/Company/wpp-group-plc/',
  ],
];

const PhotoItem = ({ image, text, link }) => (
  <Col
    sm={4}
    md={3}
    lg={3}
    className='gallery-item'
    style={{ position: 'relative' }}
  >
    <Item
      original={image}
      thumbnail={image}
      width={1024}
      height={600}
      title={text}
    >
      {({ ref, open }) => (
        <div
          ref={ref}
          onClick={open}
          className='react_lightgallery_item'
          style={{ cursor: 'pointer', position: 'relative' }}
        >
          <img src={image} alt={text} style={{ width: '100%' }} />
          <div className='mask'>
            <span className='mask-desc h4'>{text}</span>
            <a
              className='mask-link'
              href={link}
              target='_blank'
              rel='noopener noreferrer'
              style={{ color: 'white', marginTop: '8px' }}
              onClick={(e) => e.stopPropagation()}
            >
              <FontAwesomeIcon icon={faLink} />
            </a>
          </div>
        </div>
      )}
    </Item>
  </Col>
);

const PhotoGallery = () => {
  useEffect(() => {
    const portfolioDiv = document.querySelector('.portfolio');
    if (!portfolioDiv) return;

    const toggleZIndex = () => {
      const isOpen = !!document.querySelector('.pswp--open');
      portfolioDiv.style.zIndex = isOpen ? '100' : '';
    };

    toggleZIndex(); // initial check

    const observer = new MutationObserver(toggleZIndex);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      portfolioDiv.style.zIndex = '';
    };
  }, []);
  return (
    <div className='gallery'>
      <Gallery>
        <Row className='gallery-list'>
          {images.map(([image, text, link], idx) => (
            <PhotoItem key={idx} image={image} text={text} link={link} />
          ))}
        </Row>
      </Gallery>
    </div>
  );
};

export default PhotoGallery;
